<!-- eslint-disable max-len, vue/no-confusing-v-for-v-if -->
<template>
  <div>
    <draggable
      :options="{
        animation:300,
        handle:'.icon-drag'
      }"
      :list="dataActions"
      group="blockActionDragg"
      @start="handleStartDrag"
      @end="handleEndDrag"
    >
      <!-- Data Actions -->
      <div
        v-for="(val, index) in dataActions"
        :key="val.id"
        :data-parent="JSON.stringify(dataParent)"
        :row="row"
      >

        <!-- Add Block Action Between -->
        <div
          :id="`automationAddBlock-${val.id}`"
          class="btn-action-add-automation-plus"
          @click="openPopoverAdd(`popoverAddAutomationBlock-${val.id}`)"
        >
          <i class="fa fa-plus"/>
        </div>

        <b-popover
          v-if="popoverAddBlock && popoverAddBlock === `popoverAddAutomationBlock-${val.id}`"
          :ref="`popoverAddAutomationBlock-${val.id}`"
          :target="`automationAddBlock-${val.id}`"
          triggers="manual"
          placement="bottom">
          <ModalListAction
            v-click-outside="hideAllPopoverAdd"
            :last-index="index"
            :modal-ref="`popoverAddAutomationBlock-${val.id}`"
            @select="selectActionBlock"
          />
          <!-- <div
            class="add-automation"
            @click="addBlockInBetween('action', index, `popoverAddAutomationBlock-${val.id}`)">
            <img
              :src="require('@/assets/automation/action-lg.png')"
              width="18"
              class="m__r--5">Action</div>
          <div
            class="add-automation"
            @click="addBlockInBetween('conditional', index, `popoverAddAutomationBlock-${val.id}`)">
            <img
              :src="require('@/assets/automation/conditional.svg')"
              width="18"
              class="m__r--5">Conditional</div>
          <div
            class="add-automation"
            @click="addBlockInBetween('while', index, `popoverAddAutomationBlock-${val.id}`)">
            <img
              :src="require('@/assets/automation/while.svg')"
              width="18"
              class="m__r--5">While</div>
          <div
            class="add-automation"
            @click="addBlockInBetween('javascript', index, `popoverAddAutomationBlock-${val.id}`)">
            <img
              :src="require('@/assets/automation/script.svg')"
              width="18"
              class="m__r--5">Script</div> -->
        </b-popover>

        <!-- Block Action -->
        <j-automation-action
          v-if="val.type === 'action'"
          :ref="`automationAction-${val.id}`"
          :id="val.id"
          :data-index="index"
          :data-edit="val.dataEdit"
          :data-parent="dataParent"
          :row="row" />

        <!-- Block Javascript -->
        <j-automation-javascript
          v-if="val.type === 'javascript'"
          :ref="`automationJavascript-${val.id}`"
          :id="val.id"
          :data-index="index"
          :data-edit="val.dataEdit"
          :data-parent="dataParent"
          :row="row" />

        <!-- Block Conditional -->
        <j-automation-conditional
          v-if="val.type === 'conditional'"
          :ref="`automationConditional-${val.id}`"
          :id="val.id"
          :data-index="index"
          :data-edit="val.dataEdit"
          :data-parent="dataParent"
          :row="row" />

        <!-- Block While -->
        <j-automation-while
          v-if="val.type === 'while'"
          :ref="`automationWhile-${val.id}`"
          :id="val.id"
          :data-index="index"
          :data-edit="val.dataEdit"
          :data-parent="dataParent"
          :row="row" />

        <div class="hierarchy-line-vertical"/>
        <div
          v-if="val.type !== 'conditional' && val.type !== 'while'"
          class="hierarchy-line-arrow-down"
        />

        <div
          v-if="(val.type === 'conditional' || val.type === 'while') && val.dataEdit"
          class="wrap-tree-layer"
        >
          <!-- Array Left -->
          <div class="wrap-layer-left">
            <!-- Horizontal top line for block conditional -->
            <div class="horizontal-line-left">
              <div class="line" />
            </div>

            <div
              :class="{ 'label-while-conditional': val.type === 'while' }"
              class="label-true-conditional"
            >
              {{ val.type === 'conditional' ? 'TRUE' : 'WHILE' }}
            </div>

            <!-- Vertical line -->
            <div class="hierarchy-line-vertical-true" />
            <div class="hierarchy-line-arrow-down" />

            <div class="wrap-diagram-tree">
              <diagram-view
                :data-actions="val.array_left"
                :row="row + 1"
                :data-parent="[...dataParent, { index: index, type: val.type, position: 'array_left', is_disable: val.dataEdit.is_disable }]"
              />

              <!-- Add Block Action Last Block -->
              <div
                :id="`automationAddLeft-${val.id}`"
                class="btn-action-add-automation-plus"
                style="margin-bottom: 20px;"
                @click="openPopoverAdd(`popoverAddAutomationLeft-${val.id}`)"
              >
                <i class="fa fa-plus"/>
              </div>

              <b-popover
                v-if="popoverAddBlock && popoverAddBlock === `popoverAddAutomationLeft-${val.id}`"
                :ref="`popoverAddAutomationLeft-${val.id}`"
                :target="`automationAddLeft-${val.id}`"
                triggers="manual"
                placement="bottom">
                <ModalListAction
                  v-click-outside="hideAllPopoverAdd"
                  :last-index="index"
                  :modal-ref="`popoverAddAutomationLeft-${val.id}`"
                  :position="'array_left'"
                  :row="row + 1"
                  :data-parent="[...dataParent, { index: index, type: val.type, position: 'array_left' }]"
                  @select="selectActionBlock"
                />
                <!-- <div
                  class="add-automation"
                  @click="addBlockInLast('action',
                                         'array_left',
                                         index,
                                         `popoverAddAutomationLeft-${val.id}`,
                                         row + 1,
                                         [...dataParent, { index: index, type: val.type, position: 'array_left' }])">
                  <img
                    :src="require('@/assets/automation/action-lg.png')"
                    width="18"
                    class="m__r--5">Action</div>
                <div
                  class="add-automation"
                  @click="addBlockInLast('conditional',
                                         'array_left',
                                         index,
                                         `popoverAddAutomationLeft-${val.id}`,
                                         row + 1,
                                         [...dataParent, { index: index, type: val.type, position: 'array_left' }])">
                  <img
                    :src="require('@/assets/automation/conditional.svg')"
                    width="18"
                    class="m__r--5">Conditional</div>
                <div
                  class="add-automation"
                  @click="addBlockInLast('while',
                                         'array_left',
                                         index,
                                         `popoverAddAutomationLeft-${val.id}`,
                                         row + 1,
                                         [...dataParent, { index: index, type: val.type, position: 'array_left' }])">
                  <img
                    :src="require('@/assets/automation/while.svg')"
                    width="18"
                    class="m__r--5">While</div>
                <div
                  class="add-automation"
                  @click="addBlockInLast('javascript',
                                         'array_left',
                                         index,
                                         `popoverAddAutomationLeft-${val.id}`,
                                         row + 1,
                                         [...dataParent, { index: index, type: val.type, position: 'array_left' }])">
                  <img
                    :src="require('@/assets/automation/script.svg')"
                    width="18"
                    class="m__r--5">Script</div> -->
              </b-popover>

              <!-- Vertical line -->
              <div
                class="hierarchy-line-vertical"
              >
                <div class="dots-line" />
              </div>
            </div>

            <!-- Horizontal bottom line for block conditional -->
            <div class="horizontal-line-bottom-left">
              <div class="line" />
            </div>
          </div>

          <!-- Array right -->
          <div class="wrap-layer-right">
            <!-- Horizontal top line for block conditional -->
            <div class="horizontal-line-right">
              <div class="line" />
            </div>

            <div
              :class="{ 'label-done-conditional': val.type === 'while' }"
              class="label-false-conditional"
            >
              {{ val.type === 'conditional' ? 'FALSE' : 'DONE' }}
            </div>

            <!-- Vertical line -->
            <div class="hierarchy-line-vertical-false" />
            <div class="hierarchy-line-arrow-down" />

            <div class="wrap-diagram-tree">
              <diagram-view
                :data-actions="val.array_right"
                :row="row + 1"
                :data-parent="[...dataParent, { index: index, type: val.type, position: 'array_right', is_disable: val.dataEdit.is_disable }]"
              />

              <!-- Add Block Action Last Block -->
              <div
                :id="`automationAddRight-${val.id}`"
                class="btn-action-add-automation-plus"
                style="margin-bottom: 20px;"
                @click="openPopoverAdd(`popoverAddAutomationRight-${val.id}`)"
              >
                <i class="fa fa-plus"/>
              </div>

              <b-popover
                v-if="popoverAddBlock && popoverAddBlock === `popoverAddAutomationRight-${val.id}`"
                :ref="`popoverAddAutomationRight-${val.id}`"
                :target="`automationAddRight-${val.id}`"
                triggers="manual"
                placement="bottom">
                <ModalListAction
                  v-click-outside="hideAllPopoverAdd"
                  :last-index="index"
                  :modal-ref="`popoverAddAutomationRight-${val.id}`"
                  :position="'array_right'"
                  :row="row + 1"
                  :data-parent="[...dataParent, { index: index, type: val.type, position: 'array_right' }]"
                  @select="selectActionBlock"
                />
                <!-- <div
                  class="add-automation"
                  @click="addBlockInLast('action',
                                         'array_right',
                                         index,
                                         `popoverAddAutomationRight-${val.id}`,
                                         row + 1,
                                         [...dataParent, { index: index, type: val.type, position: 'array_right' }])">
                  <img
                    :src="require('@/assets/automation/action-lg.png')"
                    width="18"
                    class="m__r--5">Action</div>
                <div
                  class="add-automation"
                  @click="addBlockInLast('conditional',
                                         'array_right',
                                         index,
                                         `popoverAddAutomationRight-${val.id}`,
                                         row + 1,
                                         [...dataParent, { index: index, type: val.type, position: 'array_right' }])">
                  <img
                    :src="require('@/assets/automation/conditional.svg')"
                    width="18"
                    class="m__r--5">Conditional</div>
                <div
                  class="add-automation"
                  @click="addBlockInLast('while',
                                         'array_right',
                                         index,
                                         `popoverAddAutomationRight-${val.id}`,
                                         row + 1,
                                         [...dataParent, { index: index, type: val.type, position: 'array_right' }])">
                  <img
                    :src="require('@/assets/automation/while.svg')"
                    width="18"
                    class="m__r--5">While</div>
                <div
                  class="add-automation"
                  @click="addBlockInLast('javascript',
                                         'array_right',
                                         index,
                                         `popoverAddAutomationRight-${val.id}`,
                                         row + 1,
                                         [...dataParent, { index: index, type: val.type, position: 'array_right' }])">
                  <img
                    :src="require('@/assets/automation/script.svg')"
                    width="18"
                    class="m__r--5">Script</div> -->
              </b-popover>

              <!-- Vertical line -->
              <div
                class="hierarchy-line-vertical"
              >
                <div class="dots-line" />
              </div>
            </div>

            <!-- Horizontal bottom line for block conditional -->
            <div class="horizontal-line-bottom-right">
              <div class="line" />
            </div>
          </div>
        </div>

        <!-- Vertical line -->
        <template v-if="val.type === 'conditional' || val.type === 'while'">
          <div class="hierarchy-line-vertical-true" />
          <div class="hierarchy-line-arrow-down" />
        </template>
      </div>
    </draggable>
  </div>
</template>

<script>
/* eslint-disable no-nested-ternary, no-console, max-len, no-unused-vars, func-names, object-shorthand, semi */
import { mapMutations, mapState } from 'vuex';

import draggable from 'vuedraggable';
import jAutomationTrigger from '@/views/visual-programming/jVPBlockTrigger';
import jAutomationAction from '@/views/visual-programming/jVPBlockAction';
import jAutomationConditional from '@/views/visual-programming/jVPBlockConditional';
import jAutomationWhile from '@/views/visual-programming/jVPBlockWhile';
import jAutomationJavascript from '@/views/visual-programming/jVPBlockJavascript';
import ModalListAction from '@/views/visual-programming/popup/ModalListAction';

import DiagramView from '@/views/visual-programming/DiagramView';
import ClickOutside from 'vue-click-outside';

export default {
  name: 'DiagramView',
  components: {
    draggable,
    jAutomationTrigger,
    jAutomationAction,
    jAutomationConditional,
    jAutomationWhile,
    jAutomationJavascript,
    ModalListAction,

    DiagramView,
  },
  directives: {
    ClickOutside,
  },
  props: {
    dataActions: {
      type: Array,
      default: () => [],
    },
    row: {
      type: Number,
      default: 0,
    },
    dataParent: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      targetMoved: null,
    };
  },
  computed: {
    ...mapState('jStoreAutomation', ['propertiesOpened', 'popoverAddBlock']),
  },
  methods: {
    ...mapMutations('jStoreAutomation', [
      'setPropertiesOpened',
      'setPopoverAddBlock',
      'setDataDragBlockAction',
      'setDataDropBlockAction',
    ]),

    openPopoverAdd(dataRef) {
      this.hideAllPopoverAdd();

      setTimeout(() => {
        this.setPopoverAddBlock(dataRef);

        setTimeout(() => {
          this.$refs[dataRef][0].$emit('open');
        }, 200)
      }, 150);
    },

    hideAllPopoverAdd() {
      if (this.popoverAddBlock && this.$refs[this.popoverAddBlock]) {
        this.$refs[this.popoverAddBlock][0].$emit('close');
      }
      this.setPopoverAddBlock(null);
    },

    addBlockInBetween(type, lastIndex, ref) {
      const data = {
        id: Number(`${Math.floor(Math.random() * 100)}${Math.floor(Math.random() * 100)}`),
        type,
        dataEdit: null,
        array_left: [],
        array_right: [],
      };
      this.dataActions.splice(lastIndex, 0, data);
      this.showProperties(data.id, type, lastIndex);
      this.$refs[String(ref)][0].$emit('close');
    },

    addBlockInLast(type, position, lastIndex, ref, row, dataParent) {
      const data = {
        id: Number(`${Math.floor(Math.random() * 100)}${Math.floor(Math.random() * 100)}`),
        type,
        dataEdit: null,
        array_left: [],
        array_right: [],
      };
      this.dataActions[lastIndex][position].push(data);
      this.showProperties(data.id, type, this.dataActions[lastIndex][position].length - 1, row, dataParent);
      this.$refs[String(ref)][0].$emit('close');
    },

    showProperties(id, type, lastIndex, row, dataParent) {
      if (this.propertiesOpened) {
        this.setPropertiesOpened({ open: false });

        setTimeout(() => {
          this.setPropertiesOpened({
            open: true,
            type,
            index: lastIndex,
            row: row || this.row,
            dataParent: dataParent || this.dataParent,
            idBlock: id,
          });
        }, 100);
      } else {
        this.setPropertiesOpened({
          open: true,
          type,
          index: lastIndex,
          row: row || this.row,
          dataParent: dataParent || this.dataParent,
          idBlock: id,
        });
      }
    },

    handleStartDrag(evt) {
      const element = evt.to.querySelector('div');
      this.setDataDragBlockAction({
        index: evt.oldIndex,
        data_parent: JSON.parse(element.getAttribute('data-parent')),
        row: element.getAttribute('row'),
      });
    },

    handleEndDrag(evt) {
      const element = evt.to.querySelector('div');
      this.setDataDropBlockAction({
        index: evt.newIndex,
        data_parent: JSON.parse(element.getAttribute('data-parent')),
        row: element.getAttribute('row'),
      });
    },

    selectActionBlock(data) {
      if (data.position) {
        this.addBlockInLast(data.type, data.position, data.last_index, data.modal_ref, data.row, data.data_parent);
      } else {
        this.addBlockInBetween(data.type, data.last_index, data.modal_ref);
      }
      this.hideAllPopoverAdd();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/DiagramView.vue